import {
  SET_USER,
  SET_ERRORS,
  CLEAR_ERRORS,
  LOADING_UI,
  SET_UNAUTHENTICATED,
  LOCATION_TYPE,
  SEAT_LIST,
  LOADER_FALSE,
  LOADER_CHECK,
  SEAT_EDIT_MAPPING,
  REMOVE_LIST_MAPPING,
  SEAT_MAPPING_DATA,
  LOCATION_LIST_ALL,
  SEAT_BOOKING_PANNEL,
  GET_SEAT_COORDS,
} from '../type';
import axios from 'axios';
import { toast } from 'react-toastify';
import {
  SeatListUrl,
  LocationListUrl,
  SeatMapingData,
  SeatEdit,
  listRemove,
  LocationFilter,
  seatBookingUrl,
  SeatNumberByLocation,
  flexiSeatCoordsUrl,
} from '../../Component/Helpers/api';
import $ from 'jquery';

export const SeatData = pageDetail => dispatch => {
  let authToken = JSON.parse(localStorage.getItem('headData'))
  dispatch({ type: LOADING_UI });
  axios
    .post(SeatListUrl.data, pageDetail, {
      headers: {

        Authorization: authToken?.spintlyToken,

      }
    })
    .then(res => {
      if (res.status === 200) {
        dispatch({ type: SEAT_LIST, payload: res.data.data });
        dispatch({ type: CLEAR_ERRORS });
        dispatch({ type: LOADER_CHECK });
        // $('.close').click();
        // toast.success(res.data.message, {
   
        // });
      } else {
        dispatch({ type: CLEAR_ERRORS });
        toast.error(res.data.message, {
    
        });
        dispatch({ type: CLEAR_ERRORS });
      }
    })
    .catch(error => {
      dispatch({ type: CLEAR_ERRORS });
    });
};

export const SelectLocation = pageDetail => dispatch => {
  let authToken = JSON.parse(localStorage.getItem('headData'))
  dispatch({ type: LOADING_UI });
  axios
    .post(LocationListUrl.data, pageDetail, {
      headers: {

        Authorization: authToken?.spintlyToken,

      }
    })
    .then(res => {
      if (res.status === 200) {
        dispatch({ type: LOCATION_TYPE, payload: res.data.data });
        dispatch({ type: CLEAR_ERRORS });
        dispatch({ type: LOADER_CHECK });
        // $('.close').click();
        // toast.success(res.data.message, {
   
        // });
      } else {
        dispatch({ type: CLEAR_ERRORS });
        toast.error(res.data.message, {
    
        });
        dispatch({ type: CLEAR_ERRORS });
      }
    })
    .catch(error => {
      dispatch({ type: CLEAR_ERRORS });
    });
};

export const SeatMappingName = pageDetail => dispatch => {
  let authToken = JSON.parse(localStorage.getItem('headData'))
  dispatch({ type: LOADING_UI });
  axios
    .post(SeatMapingData.data, pageDetail, {
      headers: {

        Authorization: authToken?.spintlyToken,

      },
    })
    .then(res => {
      if (res.status === 200) {
        dispatch({ type: SEAT_MAPPING_DATA, payload: res.data.data });
        dispatch({ type: CLEAR_ERRORS });
        dispatch({ type: LOADER_CHECK });
        //$('.close').click();
        // toast.success(res.data.message, {
   
        // });
      } else {
        dispatch({ type: CLEAR_ERRORS });
        toast.error(res.data.message, {
    
        });
        dispatch({ type: CLEAR_ERRORS });
      }
    })
    .catch(error => {
      dispatch({ type: CLEAR_ERRORS });
    });
};

export const seatbookingData = pageDetail => dispatch => {
  let authToken = JSON.parse(localStorage.getItem('headData'))
  dispatch({ type: LOADING_UI });
  axios
    .post(seatBookingUrl.data, pageDetail, {
      headers: {

        Authorization: authToken?.spintlyToken,

      }
    })
    .then(res => {
      if (res.status === 200) {
        dispatch({ type: SEAT_BOOKING_PANNEL, payload: res.data });
        dispatch({ type: CLEAR_ERRORS });
        dispatch({ type: LOADER_CHECK });
        $('.close').click();
        toast.success(res.data.status_message, {
    
        });
      } else {
        dispatch({ type: CLEAR_ERRORS });
        toast.error(res.data.message, {
    
        });
        dispatch({ type: CLEAR_ERRORS });
      }
    })
    .catch(error => {
      dispatch({ type: CLEAR_ERRORS });
    });
};

export const PostEditData = pageDetail => dispatch => {
  let authToken = JSON.parse(localStorage.getItem('headData'))
  dispatch({ type: LOADING_UI });
  axios
    .post(SeatEdit.data, pageDetail, {
      headers: {

        Authorization: authToken?.spintlyToken,

      }
    })
    .then(res => {
      if (res.status === 200) {
        toast.success('Data Updated Successfully', {
    
        });
        dispatch({ type: SEAT_EDIT_MAPPING, payload: res });
        dispatch({ type: CLEAR_ERRORS });
        dispatch({ type: LOADER_CHECK });
        $('.close').click();
      } else {
        dispatch({ type: CLEAR_ERRORS });
        toast.error(res.data.message, {
    
        });
        dispatch({ type: CLEAR_ERRORS });
      }
    })
    .catch(error => {
      dispatch({ type: CLEAR_ERRORS });
    });
};

export const SetRemoveList = pageDetail => dispatch => {
  let authToken = JSON.parse(localStorage.getItem('headData'))
  dispatch({ type: LOADING_UI });
  axios
    .post(listRemove.data, pageDetail, {
      headers: {

        Authorization: authToken?.spintlyToken,

      }
    })
    .then(res => {
      if (res.status === 200) {
        dispatch({ type: REMOVE_LIST_MAPPING, payload: res });
        dispatch({ type: CLEAR_ERRORS });
        dispatch({ type: LOADER_CHECK });
        $('.close').click();
      } else {
        dispatch({ type: CLEAR_ERRORS });
        toast.error(res.data.message, {
    
        });
        dispatch({ type: CLEAR_ERRORS });
      }
    })
    .catch(error => {
      dispatch({ type: CLEAR_ERRORS });
    });
};

export const LocationFilterAction = param => dispatch => {
  dispatch({ type: LOADING_UI });
  axios
    .get(`${LocationFilter.data}?spoc=${param.spoc}&client=${param.client}`)
    .then(res => {
      if (res.status === 200) {
        dispatch({ type: LOCATION_LIST_ALL, payload: res });
        $('.close').click();
        // toast.success(res.data.message, {
   
        // });
      } else {
        dispatch({ type: CLEAR_ERRORS });
        toast.error(res.data.message, {
    
        });
        dispatch({ type: CLEAR_ERRORS });
      }
    })
    .catch(error => {
      dispatch({ type: CLEAR_ERRORS });
    });
};

export const SeatListingDataBasedOnLocation = pageDetail => dispatch => {
  let authToken = JSON.parse(localStorage.getItem('headData'))
  dispatch({ type: LOADING_UI });
  axios
    .post(SeatNumberByLocation.data, pageDetail, {
      headers: {
        Authorization: authToken?.spintlyToken,
      }
    })
    .then(res => {
      if (res.status === 200 || res.status === 202) {
        dispatch({ type: SEAT_LIST, payload: res.data.data });
        // dispatch({ type: CLEAR_ERRORS });
        // dispatch({ type: LOADER_CHECK });
      } else {
        dispatch({ type: CLEAR_ERRORS });
        toast.error(res.data.message, {
    
        });
        dispatch({ type: CLEAR_ERRORS });
      }
    })
    .catch(error => {
      dispatch({ type: CLEAR_ERRORS });
    });
};

export const SeatCoordsData = pageDetail => dispatch => {
  let authToken = JSON.parse(localStorage.getItem('headData'))
  dispatch({ type: LOADER_FALSE });
  axios
    .post(flexiSeatCoordsUrl.data, pageDetail, {
      headers: {
        Authorization: authToken?.spintlyToken,
      }
    })
    .then(res => {
      if (res.status === 200) {
        dispatch({ type: GET_SEAT_COORDS, payload: res.data.data.data.co_ordinates });
        dispatch({ type: CLEAR_ERRORS });
        dispatch({ type: LOADER_CHECK });
        // $('.close').click();
        // toast.success(res.data.message, {
   
        // });
      } else {
        dispatch({ type: CLEAR_ERRORS });
        toast.error(res.data.message, {
    
        });
        dispatch({ type: CLEAR_ERRORS });
      }
    })
    .catch(error => {
      dispatch({ type: CLEAR_ERRORS });
      dispatch({ type: LOADER_CHECK });
    });
};

export const CheckLoader = () => dispatch => {
  dispatch({ type: LOADER_FALSE });
};
